import React from "react";
//eslint-disable-next-line no-unused-vars
import { Link } from "react-router-dom";
//eslint-disable-next-line no-unused-vars
import Tabbable from "../../../components/tabbable";
import "./loginFooter.scss";

const Footer = props => (
  <div className="columns">
    <div className="column centered is-4 is-offset-4 login-footer">
      <div className="login-footer-label">Não tem um plano?</div>
      <div className="login-footer-action">
        {props.onDoRegister ? (
          <Tabbable className="btn" onClick={props.onDoRegister}>
            Assine agora mesmo!
          </Tabbable>
        ) : (
          <Link to="/cadastrar" dark small rounded className="btn" onClick={props.onDoRegister}>
            Assine agora mesmo!
          </Link>
        )}
      </div>
    </div>
  </div>
);

export default Footer;
